"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.displayErrors = exports.displayIssues = exports.displayDependencies = exports.selectDisplayStrategy = exports.displaySignatures = void 0;
const chalk = require("chalk");
const common_1 = require("./common");
const object_1 = require("../utils/object");
function displaySignatures(scanResults) {
    const result = [chalk.whiteBright('Signatures')];
    for (const { facts = [] } of scanResults) {
        for (const { data = [] } of facts) {
            for (const { path, hashes_ffm } of data) {
                if (path && (hashes_ffm === null || hashes_ffm === void 0 ? void 0 : hashes_ffm.length) && hashes_ffm[0].data) {
                    result.push(`${hashes_ffm[0].data} ${path}`);
                }
            }
        }
    }
    if (result.length) {
        result.push('');
    }
    return result;
}
exports.displaySignatures = displaySignatures;
function findDependencyLines(depGraph, options, depsFilePaths, fileSignaturesDetails) {
    const displayDepsWithPaths = (options && options['print-dep-paths']) || false;
    const displayDeps = (options && options['print-deps']) || false;
    if (displayDepsWithPaths) {
        return displayDependencies(depGraph, fileSignaturesDetails, depsFilePaths);
    }
    else if (displayDeps) {
        return displayDependencies(depGraph, fileSignaturesDetails);
    }
    return [];
}
function selectDisplayStrategy(options, depGraph, testResult) {
    const { depsFilePaths, issues, issuesData, fileSignaturesDetails, } = testResult;
    const dependencySection = findDependencyLines(depGraph, options, depsFilePaths, fileSignaturesDetails);
    const issuesSection = displayIssues(depGraph, issues, issuesData, options === null || options === void 0 ? void 0 : options.supportUnmanagedVulnDB);
    return [dependencySection, issuesSection];
}
exports.selectDisplayStrategy = selectDisplayStrategy;
function displayDependencies(depGraph, fileSignaturesDetails, depsFilePaths = {}) {
    var _a;
    let result = [];
    const dependencies = depGraph === null || depGraph === void 0 ? void 0 : depGraph.getDepPkgs();
    const hasDependencies = (dependencies === null || dependencies === void 0 ? void 0 : dependencies.length) > 0;
    if (!hasDependencies) {
        return result;
    }
    result.push(chalk.whiteBright('\nDependencies:\n'));
    for (const { name, version } of dependencies) {
        const dependencyId = `${name}@${version}`;
        result.push(`\n${common_1.leftPad(dependencyId, 2)}`);
        if (fileSignaturesDetails && ((_a = fileSignaturesDetails[dependencyId]) === null || _a === void 0 ? void 0 : _a.confidence)) {
            result.push(common_1.leftPad(`confidence: ${fileSignaturesDetails[dependencyId].confidence.toFixed(3)}`, 2));
        }
        if (!object_1.isEmpty(depsFilePaths)) {
            const displayDepsFilePathsOutput = displayDepsFilePaths(depsFilePaths, dependencyId);
            result = [...result, ...displayDepsFilePathsOutput];
        }
    }
    if (result.length) {
        result.push('');
    }
    return result;
}
exports.displayDependencies = displayDependencies;
function displayDepsFilePaths(depsFilePaths, dependencyId) {
    const maxFilePathsToBeDisplayed = 3;
    const result = [];
    result.push(`${common_1.leftPad('matching files:', 2)}`);
    const filePathsToDisplay = depsFilePaths[dependencyId].slice(0, maxFilePathsToBeDisplayed);
    for (const filePathToDisplay of filePathsToDisplay) {
        result.push(common_1.leftPad(`- ${filePathToDisplay}`, 4));
    }
    if (depsFilePaths[dependencyId].length > 3) {
        result.push(common_1.leftPad(`... and ${depsFilePaths[dependencyId].length -
            maxFilePathsToBeDisplayed} more files`, 4));
    }
    return result;
}
function displayIssues(depGraph, issues, issuesData, supportUnmanagedVulnDB = false) {
    const result = [];
    const dependencies = depGraph === null || depGraph === void 0 ? void 0 : depGraph.getDepPkgs();
    const dependenciesCountMsg = (dependencies === null || dependencies === void 0 ? void 0 : dependencies.length) == 1
        ? '1 dependency'
        : `${dependencies === null || dependencies === void 0 ? void 0 : dependencies.length} dependencies`;
    const issuesCount = issues.length == 1 ? '1 issue' : `${issues.length} issues`;
    const hasIssues = issues.length > 0;
    if (hasIssues) {
        result.push(chalk.whiteBright('Issues:'));
        for (const { pkgName: name, pkgVersion: version, issueId: vulnId, } of issues) {
            const { title, severity } = issuesData[vulnId];
            const color = common_1.getColorBySeverity(severity);
            const severityAndTitle = color(`\n ✗ [${common_1.capitalize(severity)}] ${title}`);
            const vulnDetailsUrl = supportUnmanagedVulnDB
                ? `https://security.snyk.io/vuln/${vulnId}`
                : `https://nvd.nist.gov/vuln/detail/${vulnId}`;
            const introducedThrough = common_1.leftPad(`Introduced through: ${name}@${version}`);
            const urlText = common_1.leftPad(`URL: ${vulnDetailsUrl}`);
            result.push(severityAndTitle);
            result.push(introducedThrough);
            result.push(urlText);
        }
        result.push('');
    }
    const issuesFound = hasIssues
        ? chalk.redBright(issuesCount)
        : chalk.greenBright(issuesCount);
    const identifiedUnmanagedDeps = `Tested ${dependenciesCountMsg} for known issues, found ${issuesFound}.\n`;
    if ((dependencies === null || dependencies === void 0 ? void 0 : dependencies.length) > 0) {
        result.push(identifiedUnmanagedDeps);
    }
    return result;
}
exports.displayIssues = displayIssues;
function displayErrors(errors) {
    const result = [];
    if (errors.length) {
        result.push(chalk.redBright('Errors'));
    }
    for (const error of errors) {
        result.push(error);
    }
    if (result.length) {
        result.push('');
    }
    return result;
}
exports.displayErrors = displayErrors;
//# sourceMappingURL=display.js.map